import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, headers, multipartHeaders, isExpiredJwt, 
    renderRedirect, setTokenHeader, getJwtFromCookies, setMutipartTokenHeader, IsMbrRoleCP } from "../../module_auth/AuthService" 
import { useNavigate } from "react-router-dom";
import { SelectCityList } from '../common/SelectList';
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"
import { FileUploadButton } from "../common/FileUploadButton"
import parse from 'html-react-parser';
import { INVALID_POST_AUTHORIZATION } from '../../component/common/Message'
import { CheckAndShowLogo } from "../../component/common/Logo"
import { getUniqLogoUrl, getEmptyLogoUrl } from "../../component/common/BaseUtil"

import ReactQuill from 'react-quill';
import QuillResizeImage from 'quill-resize-image';
import Quill from "quill";
import 'react-quill/dist/quill.snow.css';
Quill.register("modules/resize", QuillResizeImage);

// url /job_reg_mypage
export function JobRegMypage() {
    const navigate = useNavigate();
    
    const [objTitle, setObjTitle] = useState("");

    //회사정보
    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [telno, setTelno] = useState("");
    const [fullname, setFullname] = useState("");
    const [cpIntro, setCpIntro] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [workCity, setWorkCity] = useState("0");

    //근무형태 체크박스
    const [checkedWorktimeFull, setCheckedWorktimeFull] = useState(false);
    const [checkedWorktimePart, setCheckedWorktimePart] = useState(false);
    const [checkedWorktimeMini, setCheckedWorktimeMini] = useState(false);

    const [applyCond, setApplyCond] = useState("");
    const [regJob, setRegJob] = useState("");

    //비자조건 체크박스
    const [checkedVisaCondWorking, setCheckedVisaCondWorking] = useState(false);
    const [checkedVisaCondHoli, setCheckedVisaCondHoli] = useState(false);
    const [checkedVisaCondSeek, setCheckedVisaCondSeek] = useState(false);
    const [checkedVisaCondStd, setCheckedVisaCondStd] = useState(false);

    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("/");
    const [accessToken, setAccessToken] = useState("");

    const [value, setValue] = useState('');
    const [fileData, setFileData] = useState('');
    const [fileExist, setFileExist] = useState(false);

    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");

    const [showAlertWarn, setShowAlertWarn] = useState(false);
    const [alertWarn, setAlertWarn] = useState("");

    const [cityList, setCityList] = useState([]);
    
    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    //modal
    const [showModal, setShowModal] = useState(false);
    
    const [logoName, setLogoName] = useState("");
    const [logoFormat, setLogoFormat] = useState("");
    const [uniqLogoName, setUniqLogoName] = useState("");

    //logo
    const [logoEntity, setLogoEntity] = useState(null);

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            setRedirectUrl("/login")
            setRedirect(true)
        } else if(!IsMbrRoleCP(getJwtFromCookies())) {
            setRedirectUrl("/")
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            getCpData()
            getCityList()
        }
    }, []);

    function getCpData(){
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/get/cp/mypage', 
        {method:'GET', headers,
        body:JSON.stringify()})
        .then(response => response.json())
        .then(response => {
            setCpName(response.cpName)
            setCpAddress(response.cpAddress)
            setTelno(response.telno)
            setCpIntro(response.cpIntro)
            setFullname(response.fullname)
            setRecruiterName(response.recruiterName)
            setRecruiterTelno(response.recruiterTelno)
            setRecruiterEmail(response.recruiterEmail)
            setLogoEntity(response.logoEntity)
           
            if(response.logoEntity){
                setLogoName(logoEntity.logoName)
                setLogoFormat(logoEntity.logoFormat)
                setUniqLogoName(logoEntity.uniqLogoName)
                console.log(logoEntity.logoName)
            }
        }).catch(error => console.log(error))
    }

    function clickWorktimeMini() {
       if(checkedWorktimeMini){
            setCheckedWorktimeMini(false)
       } else {
            setCheckedWorktimeMini(true)
       }
    }

    function clickWorktimeFull() {
        if(checkedWorktimeFull){
             setCheckedWorktimeFull(false)
        } else {
             setCheckedWorktimeFull(true)
        }
    }

    function clickWorktimePart() {
        if(checkedWorktimePart){
             setCheckedWorktimePart(false)
        } else {
             setCheckedWorktimePart(true)
        }
    }

    function clickVisaCondWorking() {
        if(checkedVisaCondWorking){
            setCheckedVisaCondWorking(false)
        } else {
            setCheckedVisaCondWorking(true)
        }
    }

    function clickVisaCondHoli() {
        if(checkedVisaCondHoli){
            setCheckedVisaCondHoli(false)
        } else {
            setCheckedVisaCondHoli(true)
        }
    }

    function clickVisaCondSeek() {
        if(checkedVisaCondSeek){
            setCheckedVisaCondSeek(false)
        } else {
            setCheckedVisaCondSeek(true)
        }
    }

    function clickVisaCondStd() {
        if(checkedVisaCondStd){
            setCheckedVisaCondStd(false)
        } else {
            setCheckedVisaCondStd(true)
        }
    }

    function fadeOutToast(msg){
        setToastMessage(true, msg)
        setTimeout(function() {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message){
        setShowToast(show)
        setMsgToast(message)
    }

    function getCityList(){
        let url = basePort + '/get/config'
        fetch(url, 
          {method:'GET', headers,
            body:JSON.stringify()})
            .then(response => response.json())
            .then(response => {
               setCityList(response.cityEntityList)
          }).catch(error => console.log(error))
    }

    function clickSubmit(event) {
        setTokenHeader(getJwtFromCookies())
        const fetchPromise = fetch(basePort + '/post/job', 
            {method:'post', headers,
                      body:JSON.stringify({
                        objTitle:objTitle,
                        regJob:regJob,
                        workCity:workCity,
                        
                        //workTime:workTime,
                        worktimeFull:checkedWorktimeFull ? "t" : "f",
                        worktimePart:checkedWorktimePart ? "t" : "f",
                        worktimeMini:checkedWorktimeMini ? "t" : "f",
                        
                        //visaCond:visaCond,
                        visaCondWorking:checkedVisaCondWorking ? "t" : "f",
                        visaCondHoli:checkedVisaCondHoli ? "t" : "f",
                        visaCondSeek:checkedVisaCondSeek ? "t" : "f",
                        visaCondStd:checkedVisaCondStd ? "t" : "f",

                        applyCond:applyCond,
                        jobDetail:value,
                        //프리미엄등록 1, 일반등록 0
                        regType:"0",
                        //즉시 포스팅 validObj:1, 관리자승인필요 validObj:0
                        validObj:"0"
                    })})
                      .then(response => response.json())
                      .then(response => {
                        if(response.validRequest){
                            //파일 저장
                            //if file exit then run this method!
                            if(fileData != ''){
                                submitFile(response.validationMessage)
                            } else {
                                //파일 없음
                                fadeOutToast("등록 완료")
                                setTimeout(function() {
                                    moveTo()
                                }.bind(this), 3000)
                            }
                        } else {
                            //invalid by PreAuthorize
                            if(response.validationMessage == undefined){
                                fadeOutToast(INVALID_POST_AUTHORIZATION)
                            } else {
                                fadeOutToast(response.validationMessage)
                            }
                        }
            }).catch(error => console.log(error))
    }

    function submitFile(objectId){
        const formData = new FormData()
        formData.append('File', fileData)
        let headers = multipartHeaders
        setMutipartTokenHeader(getJwtFromCookies())
        fetch(basePort + '/saveImage/' + objectId,
                {method:'post', headers,
                    body:formData})
                .then(response => response.json())
                .then(response => {
                    console.log("submitFile: " + response.validRequest)
                    if(response.validRequest){
                        console.log("submitFile success")
                        fadeOutToast("등록 완료")
                        setTimeout(function() {
                            moveTo()
                        }.bind(this), 3000)
                    } else {
                        console.log("submitFile is not valid");
                        fadeOutToast(response.validationMessage)
                    }
        }).catch(function(error) {
            console.log(error);
        });
    }

    function handleImageSubmit(accessToken, response) {
        if(response.validRequest === true){
          this.setState({
            showAlertWarn:false,
          })
        } else {
          this.setState({
            showAlertWarn:true,
          })
        }
        if(response.validRequest){
          let objectId = response.validationMessage
          let objectImages = this.state.objectImages
          for (let objectImage of objectImages) {
            const formData = new FormData()
            formData.append('File', objectImage)
            let headers = multipartHeaders
            setMutipartTokenHeader(accessToken)
            fetch(basePort + '/saveImage/' + objectId,
                    {method:'post', headers,
                      body:formData})
                    .then(response => response)
                    .then(response => {
                      this.setState({
                        validReqeust:response.validRequest,
                        validationMessage:response.validationMessage,
                      })
            }).catch(function(error) {
              console.log(error);
            });
          }
        }
    }

    function moveTo() {
        let url = "/job_list_mypage"
        navigate(url);
    }

    function handleRegJob(event) {
        setRegJob(event.target.value);
    }

    function handleApplyCond(event) {
        setApplyCond(event.target.value);
    }

    function handleWorkCity(event) {
        setWorkCity(event.target.value);
    }

    function handleObjTitle(event) {
        setObjTitle(event.target.value);
    }

    function handleChooseFile(event) {
        setStateAlertWarn(false, "")
        if(event.target.files[0] == null){
            event.target.value = '';
            console.log("no choose file")
            return
        }
        let fileName = event.target.files[0].name
        let fileExt = fileName.split('.').pop()
        let fileSize = event.target.files[0].size
        console.log("choose file: " + fileName)
        console.log("choose ext: " + fileExt)
        console.log("choose size: " + fileSize)
        if(fileExt.toLowerCase() == "pdf"){
            setFileData(event.target.files[0])
            setFileExist(true)
        } else {
            setStateAlertWarn(true, "pdf 파일만 업로드 가능합니다.")
        }
    }

    function setStateAlertWarn(allowShow, message){
        setShowAlertWarn(allowShow)
        setAlertWarn(message)
    }

    function removeFile(){
        setStateAlertWarn(false, "")
        document.getElementById("chooseFile").value = ""
        setFileData("")
        setFileExist(false)
    }

    function handleImage(){
        //nothing
    }

    function closeModalBtn(){
        setShowModal(false)
    }

    function submitModalBtn(){
        setShowModal(false)
        clickSubmit()
    }

    function clickModalBtn(){
        setShowModal(true)
    }

    function clickCancelBtn(){
        setRedirect(true)
        setRedirectUrl("/job_reg_select")
    }

    return (
        <div>
            {renderRedirect(redirect, redirectUrl)}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><span>채용정보</span></li>
                        <li class="breadcrumb-item"><span>일반채용등록</span></li>
                    </ol>
                    <form><label class="form-label" style={{textAlign: 'left', fontWeight: 'bold'}}>제목</label>
                        <input class="form-control" type="text" maxlength="41" onChange={handleObjTitle}/>
                    </form>
                    <p style={{fontWeight: 'bold', marginTop: '10px', marginBottom: '10px'}}>모집요강</p>
                    <ul class="list-group">
                        <li class="list-group-item">
                            <form style={{marginTop: '10px'}}><label class="form-label">모집부문:</label>
                                <input class="form-control" type="text" onChange={handleRegJob}/>
                            </form>
                            <form style={{marginTop: '10px'}}><label class="form-label">근무도시:</label>
                                <SelectCityList optionValue={workCity} cityList={cityList} handleWorkCity={handleWorkCity}/>
                            </form>
                            <form style={{marginTop: '20px'}}>
                                <label class="form-label" style={{marginRight: '10px'}} >근무형태:</label>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimeFull" checked={checkedWorktimeFull} onChange={clickWorktimeFull}/>
                                    <label class="form-check-label" for="worktimeFull">풀타임</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimePart" checked={checkedWorktimePart} onChange={clickWorktimePart}/>
                                    <label class="form-check-label" for="worktimePart">파트타임</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="worktimeMini" checked={checkedWorktimeMini} onChange={clickWorktimeMini}/>
                                    <label class="form-check-label" for="worktimeMini">미니잡</label>
                                </div>
                            </form>
                            <form style={{marginTop: '10px'}}>
                                <label class="form-label" style={{marginRight: '10px'}} >비자조건:</label>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondWorking" checked={checkedVisaCondWorking} onChange={clickVisaCondWorking}/>
                                    <label class="form-check-label" for="visaCondWorking">워킹비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondHoli" checked={checkedVisaCondHoli} onChange={clickVisaCondHoli}/>
                                    <label class="form-check-label" for="visaCondHoli">워킹홀리데이비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondSeek" checked={checkedVisaCondSeek} onChange={clickVisaCondSeek}/>
                                    <label class="form-check-label" for="visaCondSeek">취업준비비자</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="checkbox" id="visaCondStd" checked={checkedVisaCondStd} onChange={clickVisaCondStd}/>
                                    <label class="form-check-label" for="visaCondStd">학생비자</label>
                                </div>
                            </form>
                            {/* <form style={{marginTop: '10px'}}><label class="form-label">지원조건:</label><input class="form-control" type="text" onChange={handleApplyCond}/></form> */}
                            <form style={{marginTop: '10px', marginRight: '0', marginLeft: '0'}}>
                                <label class="form-label">모집상세:</label>
                                <div class="container" style={{height:'350px', marginBottom:'10px'}}>
                                    <ReactQuill theme="snow" value={value} onChange={setValue}
                                        style={{height: '300px', marginBottom:'10px'}}
                                        modules={{
                                            toolbar: {
                                                container: [
                                                    [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                    [{ size: [] }],
                                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                    [{ 'align': [] }],
                                                    [{ list: 'ordered' }, { list: 'bullet' }],
                                                    ['image'],
                                                    ['clean'],
                                                    ['code-block']
                                                ],
                                                handlers: {
                                                    image: handleImage(),
                                                },
                                            },
                                            resize: {
                                                locale: {},
                                            },
                                        }}
                                    />
                                </div>
                            </form>
                            <FileUploadButton 
                                setFileData={setFileData}
                                setFileExist={setFileExist}
                                removeFile={removeFile}
                                fileExist={fileExist}
                            />
                        </li>
                    </ul>
                    <p style={{fontWeight: 'bold', marginTop: '10px', marginBottom: '10px'}}>기업정보</p>
                    <div className="card" style={{marginBottom: '50px'}}> 
                        <div className="card-body">
                            <div class="container text-left">
                                <div class="row g-2" >
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사명:</span> {cpName}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6" >
                                        <CheckAndShowLogo
                                            imageUrl={logoName != "" ? getUniqLogoUrl(uniqLogoName, logoFormat) : getEmptyLogoUrl("empty_logo", "png")}
                                            alt="유효한 이미지"
                                            imageAlign="left"
                                            style={{marginTop: "5px",  marginBottom: "5px"}}
                                        />
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사주소:</span> {cpAddress}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        {/* <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>대표자명:</span> {fullname}</div> */}
                                    </div>
                                    {/* <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 전화번호:</span> {recruiterTelno}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>인사담당자 이메일:</span> {recruiterEmail}</div>
                                    </div> */}
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <div class="p-3"><span style={{color:"#696969", fontWeight: 'bold'}}>회사소개:</span><br/>{cpIntro === null ? "" : parse(cpIntro)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form style={{textAlign: 'center', marginBottom: '10px', marginTop: '10px'}}>
                        <button class="btn btn-secondary" type="button" onClick={clickCancelBtn} style={{marginRight: '5px'}}>취소하기</button>
                        <button class="btn btn-primary" type="button" onClick={clickModalBtn}>일반 등록하기</button>
                    </form>
                    {/* end of container */}
                    <ToastMessage show={showToast} msg={msgToast} />
                    <ModalMessage show={showModal} closeBtn={closeModalBtn} submitBtn={submitModalBtn} title={"채용등록"} msg={"일반 채용등록을 하시겠습까?"} />
                    </div>
                </section>
            </main>
        </div>
    );
}